import { createContext, useContext, useEffect, useState } from 'react';

import { API_URLS, APPLICATION_HEADERS } from '../components/common/headers';
import { protectApiViaOkta } from '../utils/protectApiViaOkta';

export const MapContext = createContext({
  bingTileUrl: undefined,
  setBingTileUrl: () => {},
});

export const MapProvider = ({ children, value }) => {
  const [bingTileUrl, setBingTileUrl] = useState();

  useEffect(() => {
    async function waitForOktaToken() {
      return new Promise((resolve) => {
        const check = () => {
          const oktaToken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken
            ?.idToken;

          if (oktaToken) {
            resolve(oktaToken);
          } else {
            setTimeout(check, 100);
          }
        };

        check();
      });
    }
    async function fetchBingTileUrl() {
      await waitForOktaToken();
      try {
        const url = API_URLS.bingTilesUrl;
        const response = await protectApiViaOkta('get', url);

        setBingTileUrl(response.data || '');
      } catch (e) {
        console.error('Error fetching Bing Tile URL:', e);
      }
    }
    fetchBingTileUrl();
  }, []);

  return (
    <MapContext.Provider value={{ ...value, bingTileUrl, setBingTileUrl }}>
      {children}
    </MapContext.Provider>
  );
};

export const useMapContext = () => {
  return useContext(MapContext);
};
